import React from 'react';
import type { ReceptionistTimeRangeKey } from '../../../receptionist-dashboard/types';
import { Icon } from '../../Icon/Icon';
import { DashboardToggleGroup } from './DashboardToggleGroup';

const RANGES = [
  { id: 'today' as const, label: 'Today' },
  { id: '7days' as const, label: 'Last 7 days' },
  { id: '30days' as const, label: 'Last 30 days' },
  { id: 'custom' as const, label: 'Custom' },
];

export interface DashboardTimeRangeBarProps {
  value: ReceptionistTimeRangeKey;
  onChange: (value: ReceptionistTimeRangeKey) => void;
  onRefresh?: () => void;
}

export function DashboardTimeRangeBar({ value, onChange, onRefresh }: DashboardTimeRangeBarProps) {
  return (
    <div className="rcpt-mature-fade-up rcpt-mature-d-0 mb-4 flex flex-wrap items-center gap-2.5">
      <DashboardToggleGroup value={value} onChange={onChange} options={RANGES} padX={12} />

      <div className="flex-1" />

      <span className="font-[var(--font-mono)] text-[10.5px] text-[var(--ink-3)]">
        Updated <span className="font-semibold text-[var(--ink-1)]">just now</span>
      </span>
      <button
        type="button"
        onClick={onRefresh}
        className="inline-flex h-[30px] cursor-pointer items-center gap-1.5 rounded-[10px] border border-[var(--cream-2)] bg-[var(--surface-mute)] px-2.5 text-[11.5px] font-medium text-[var(--ink-1)] transition-[background,border-color] hover:bg-[var(--cream-1)]"
      >
        <Icon kind="refresh" size={11} stroke={2} />
        Refresh
      </button>
    </div>
  );
}
